import { Timestamp } from '@angular/fire/firestore';

import { ServerTimeRepository } from './server-time-repository';

export class ServerTimeMockRepository implements ServerTimeRepository {
	public get(): Promise<Timestamp> {
		return Promise.resolve(Timestamp.now());
	}
}
